import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Bankaccount = ({company_id}) => {
  let  user_id  = company_id;
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_API;
  const [countries, setCountry] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isDisable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const initialFormState = {
    bank_name: "",
    address_1: "",
    address_2: "",
    country: "",
    city: "",
    account_name: "",
    account_number: "",
    iban: "",
    swift: "",
  };

  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountry(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, [BaseUrl]);

 

  useEffect(() => {
    const fetchBankAccounts = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${BaseUrl}/getBankaccountAdmin`, {
          user_id,
        });
        setLoading(false);
        setBankAccounts(response.data);

        // If bankAccounts has data, fill the form and disable it
        if (response.data.length > 0) {
          setFormState(response.data[0]);
          setEditingIndex(0); // Disable editing
          setDisable(true);
        }
      } catch (error) {
        console.log(error.message || "Error fetching bank accounts");
      }
    };

    fetchBankAccounts();
    // eslint-disable-next-line
  }, [BaseUrl]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleAddBankAccount = () => {
    // Check if any required field is empty
    if (
      !formState.bank_name ||
      !formState.address_1 ||
      !formState.country ||
      !formState.city ||
      !formState.account_name ||
      !formState.account_number ||
      !formState.iban ||
      !formState.swift
    ) {
      toast.error("Please fill out all required fields.");
      return;
    }

    if (editingIndex === null) {
      // Add new bank account
      setBankAccounts([...bankAccounts, formState]);
    } else {
      // Update existing bank account
      const updatedBankAccounts = [...bankAccounts];
      updatedBankAccounts[editingIndex] = formState;
      setBankAccounts(updatedBankAccounts);
      setEditingIndex(null);
    }
    setFormState(initialFormState);
  };

  const handleEditBankAccount = (index) => {
    setFormState(bankAccounts[index]);
    setEditingIndex(index);
  };

  const handleDeleteBankAccount = (index) => {
    const updatedBankAccounts = [...bankAccounts];
    updatedBankAccounts.splice(index, 1);
    setBankAccounts(updatedBankAccounts);
  };

  const handleSubmitAll = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const jwtToken = localStorage.getItem("token");
      if (!jwtToken) {
        throw new Error("JWT token not found in local storage");
      }

      await axios.post(`${BaseUrl}/submitBankaccounts`, bankAccounts, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      toast.success("Bank Accounts Added Successfully!");
    } catch (err) {
      console.error("Error submitting the form:", err);
    }
  };

  const handleResetForm = () => {
    setFormState(initialFormState);
    setEditingIndex(null);
  };

  

  const getCountryName = (numCode) => {
    const country = countries?.find(
      (country) => country.NumCode && country.NumCode.toString() === numCode
    );
    return country ? country.Country : "Select";
  };

  return (
    <>
        {/* <div className="page-content"> */}
        <div className="" style={{ margin: "0", padding: "0" }}>
            {bankAccounts.length > 0 ? (
              <div id="completeform">
                <Form id="mform">
                  <Row
                    className="justify-content-center"
                    style={{ marginBottom: "50px" }}
                  >
                    <Col lg={9}>
                      {bankAccounts.map((account, index) => (
                        <Card key={index} className="mb-3">
                          <Card.Header>
                            <h5
                              className="card-title fw-bold"
                              style={{ color: "#776ad8" }}
                            >
                              Bank Account {index + 1}
                            </h5>
                          </Card.Header>
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h5 className="card-title fw-bold ">
                                  Bank Name: {account.bank_name}
                                </h5>
                                <h5 className="card-title fw-bold ">
                                  <p>Account Name: {account.account_name}</p>
                                </h5>
                              </div>
                              <div className="editDeletebtn">
                                <Button
                                  variant="primary"
                                  className="me-2"
                                  onClick={() => handleEditBankAccount(index)}
                                >
                                  {isDisable ? (
                                    <i class="fa-solid fa-eye"></i>
                                  ) : (
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  )}
                                </Button>
                                <Button
                                  variant="danger"
                                  onClick={() => handleDeleteBankAccount(index)}
                                  hidden={isDisable}
                                >
                                  <i class="fa-solid fa-trash"></i>
                                </Button>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))}
                      <Card>
                        <Card.Header>
                          <h4
                            className="card-title fw-bold"
                            style={{ color: "#776ad8" }}
                          >
                            Bank Details
                          </h4>
                        </Card.Header>
                        <Card.Body>
                          <Table striped bordered hover>
                            <tbody>
                              <tr>
                                <td className="fw-bold">Name of Bank:</td>
                                <td>{formState.bank_name}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Address (1):</td>
                                <td>{formState.address_1}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">
                                  Address (2){" "}
                                  <small className="text-muted">
                                    (Optional)
                                  </small>
                                  :
                                </td>
                                <td>{formState.address_2}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Country:</td>
                                <td>{getCountryName(formState?.country)}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">City:</td>
                                <td>{formState.city}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Account Name:</td>
                                <td>{formState.account_name}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Account Number:</td>
                                <td>{formState.account_number}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">IBAN:</td>
                                <td>{formState.iban}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">SWIFT:</td>
                                <td>{formState.swift}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Row className="justify-content-center" hidden={isDisable}>
                    <Col lg={12}>
                      <Card>
                        <Card.Header className="btn-mobile">
                          <Button
                            variant="primary"
                            type="button"
                            onClick={handleAddBankAccount}
                          >
                            {editingIndex === null
                              ? "Add Bank Account"
                              : "Update Bank Account"}
                          </Button>
                          <Button
                            variant="secondary"
                            type="button"
                            onClick={handleResetForm}
                          >
                            Reset Form
                          </Button>
                          <Button
                            variant="success"
                            type="submit"
                            onClick={handleSubmitAll}
                            disabled={bankAccounts.length <= 0}
                          >
                            Submit All
                          </Button>
                        </Card.Header>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              </div>
            ) : (
              <div className="container mt-4">
                <div className="row justify-content-center">
                  <div className="col-6">
                    <div className="card">
                      <div className="card-body text-center font-weight-bold">
                        No Bank Details submitted
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
    </>
  );
};

export default Bankaccount;
